import type { FunctionalComponent } from '@bpmn-io/properties-panel/preact';
import { useEffect, useMemo, useRef } from '@bpmn-io/properties-panel/preact/hooks';
import { jsx } from '@bpmn-io/properties-panel/preact/jsx-runtime';
import { createRoot, type Root } from 'react-dom/client';
import { useService } from '../hooks/useService';
import {
    renderPeopleFieldPicker,
    type TFieldPickerValue,
} from '../../../../pickers/PeopleFieldPicker';

interface IMailFieldsProps {
    // attrPropName: string;
    element: any;
    id: string;
    label: string;
    moddleElement: any;
    // label: string;
    type: FieldType;
    // valPropName: string;
}

enum FieldType {
    CC = 'cc',
    TO = 'to',
}

const attrPropNameByType = (type: FieldType) => {
    switch (type) {
        case FieldType.CC:
            return 'copytofield';
        case FieldType.TO:
            return 'sendtofield';
    }
};

const schemaNameByType = (type: FieldType) => {
    const prefix = 'fism:Mail';
    switch (type) {
        case FieldType.CC:
            return prefix + 'CopyToFields';
        case FieldType.TO:
            return prefix + 'SendToFields';
    }
};

export const MailRecipientFields: FunctionalComponent<IMailFieldsProps> = (props) => {
    const { element, label, moddleElement, type } = props;
    const bpmnFactory = useService('bpmnFactory');
    const modeling = useService('modeling');
    const translate = useService('translate');
    const rbo = useService('canvas').getRootElement().businessObject;
    const siteUrl: string | undefined = rbo.siteUrl;
    const list: string | undefined = rbo.listId;
    const containerRef = useRef<HTMLDivElement>();
    const rootRef = useRef<Root>();
    const attrPropName = attrPropNameByType(type);
    const attrPropValue: TFieldPickerValue | undefined = (moddleElement.get(attrPropName) || {})
        .values;

    const fields = useMemo<NonNullable<typeof attrPropValue>>(
        () =>
            Array.isArray(attrPropValue)
                ? attrPropValue.map(({ displayName, internalName }) => ({
                      displayName,
                      internalName,
                  }))
                : [],
        [attrPropValue]
    );

    useEffect(() => {
        const root = rootRef.current || createRoot(containerRef.current!);
        rootRef.current = root;
        renderPeopleFieldPicker(root, {
            label,
            list,
            onChange: (value) => {
                if (value.length > 0) {
                    const schemaName = schemaNameByType(type);
                    // create/override (to || cc) and update
                    modeling.updateModdleProperties(element, moddleElement, {
                        [attrPropName]: bpmnFactory.create(schemaName, {
                            values: value.map(({ displayName, internalName }) =>
                                bpmnFactory.create('fism:MailRecipientField', {
                                    displayName,
                                    internalName,
                                })
                            ),
                        }),
                    });
                } else if (moddleElement[attrPropName]) {
                    // remove (to || cc) and update
                    modeling.updateModdleProperties(element, moddleElement, {
                        [attrPropName]: undefined,
                    });
                }
            },
            siteUrl,
            translate,
            value: fields,
        });
    }, [label, siteUrl, fields]);

    useEffect(
        () => () => {
            if (rootRef.current) {
                rootRef.current.unmount();
            }
        },
        []
    );

    return useMemo(
        () =>
            // @ts-ignore
            jsx('div', {
                className: 'bio-properties-panel-entry',
                // 'data-entry-id': id,
                // id,
                ref: containerRef,
            }),
        []
    );
};
